module.exports = __webpack_public_path__ + "img/heating-banner.ffaecb32.jpg";